module.exports = __webpack_public_path__ + "img/8b6dc72e83a9d3e53b5eb1e635fdb72f.png";